import React, { memo } from 'react';
import cn from 'classnames';

import { WpTooltip, WpTooltipContent, WpTooltipTrigger } from 'Wpds/components/tooltip';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

import './RoundCheckbox.scss';

type Props = {
  checked: boolean;
  onToggle?: (event: React.MouseEvent<HTMLInputElement>) => void;
  className?: string;
};

function RoundCheckbox({ checked, onToggle, className }: Props) {
  const { tr } = useTranslation();
  const content = (
    <div
      className={cn(
        `round-checkbox ${className}`,
        { 'round-checkbox--is-selected': checked },
        { 'round-checkbox--not-read-only': onToggle }
      )}
      onClick={onToggle}
    >
      <div className="round-checkbox-checkmark" />
    </div>
  );

  if (!checked && onToggle) {
    return (
      <WpTooltip>
        <WpTooltipTrigger>{content}</WpTooltipTrigger>
        <WpTooltipContent>{tr('perform.common.checkbox.mark_as_complete')}</WpTooltipContent>
      </WpTooltip>
    );
  }

  return <>{content}</>;
}

export default memo(RoundCheckbox);
